import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["cx", "cy", "r", "opacity", "fill"]
const _hoisted_2 = ["begin"]


import { UseTailwindConfigReturn, useTailwindConfig } from '@/composables/use-tailwind-config';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppLoaderCircle',
  props: {
  x: {
    type: Number,
    required: true,
  },
  y: {
    type: Number,
    required: true,
  },
  radius: {
    type: Number,
    required: true,
  },
  opacity: {
    type: Number,
    required: true,
  },
  begin: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const tailwindConfig: UseTailwindConfigReturn = useTailwindConfig();

const color: string = tailwindConfig.getValue('colors', 'dark-900');

const formatAnimationBegin = (begin: number): string => {
  return `${begin}s`;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("circle", {
    cx: props.x,
    cy: props.y,
    r: props.radius,
    opacity: props.opacity,
    fill: _unref(color)
  }, [
    _createElementVNode("animate", {
      begin: formatAnimationBegin(props.begin),
      attributeName: "opacity",
      repeatCount: "indefinite",
      keyTimes: "0;1",
      values: "1;0",
      dur: "1s"
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})